import { strLang } from "../functions/strLang";

import NoResults from "../NoResults";

import MapIcon from "@mui/icons-material/Map";

import "../css/main.css";
import useTerritories from "./useTerritories";
import StdButton from "../components/StdButton";
import GenericModal from "../components/GenericModal";
import Header from "../components/Header";
import GroupsButtonsList from "./components/GroupsButtonsList";
import TerritoriesList from "./components/TerritoriesList";
import MainFrame from "../components/MainFrame";

export default function Territories({
  width,
  reloadMap,
  openMap,
  maps,
  terGroups,
  iconColor,
}) {
  const {
    open,
    closeMsg,
    msgType,
    filterMap,
    list,
    filter,
    askOpenTerritory,
    menuButtons,
    optionsButtons,
    groupScreen,
    switchGroupScreen,
    closeGroupScreen,
    clearText,
    askDelete,
    editTer,
    openRecords,
    refresh,
    setOpen,
    setSelectedTer,
  } = useTerritories({ maps, openMap, reloadMap, terGroups });

  return (
    <MainFrame width={width}>
      <Header
        MainIcon={MapIcon}
        color={iconColor}
        input={true}
        value={filter.text}
        onChange={(e) => filterMap({ text: e.target.value })}
        clear={clearText}
        refresh={refresh}
        subMenu={menuButtons.map(
          (o, index) =>
            o.active && (
              <StdButton
                key={index}
                label={o.title}
                onClick={o.func}
                color={o.color ?? null}
                width={90}
              />
            )
        )}
      >
        <StdButton
          label={`${strLang("group")}: ${
            filter.group > -1
              ? terGroups[filter.group].name
              : filter.group === -2
              ? strLang("withoutGroup")
              : strLang("all")
          }`}
          onClick={switchGroupScreen}
        />
      </Header>
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          flex: 1,
        }}
      >
        {list.length === 0 ? (
          <NoResults />
        ) : (
          <>
            <TerritoriesList
              list={list}
              askOpenTerritory={askOpenTerritory}
              terGroups={terGroups}
              openRecords={openRecords}
              editTer={editTer}
              askDelete={askDelete}
              setOpen={setOpen}
              setSelectedTer={setSelectedTer}
            />
            <GroupsButtonsList
              groupScreen={groupScreen}
              closeGroupScreen={closeGroupScreen}
              optionsButtons={optionsButtons}
              terGroups={terGroups}
              filterMap={filterMap}
              filter={filter}
            />
          </>
        )}
      </div>
      <GenericModal open={open} data={msgType[open]} close={closeMsg} />
    </MainFrame>
  );
}
